/**
 * SIGN IN (item 1).
 *
 * The password is typed here and verified in the application, holding no
 * database connection (D258, DEF-076); this screen knows none of that. What it
 * owes the person is the truth about a refusal: a throttled account and a
 * rate-limited connection are different facts and say so, because "try again"
 * on a fifteen-minute throttle wastes fifteen minutes.
 */
import * as React from 'react';
import { useState } from 'react';
import { api } from '../api.js';
import { Banner, Button, Text } from '../ui.js';
import { useRun, whereTheyWere, go } from '../hooks.js';
import { screenById } from '../../../src/screens/contracts.js';

const MESSAGES = screenById('sign-in')!.messages;

export function SignIn({ onSignedIn, failedAfterSignIn }: { onSignedIn: () => void; failedAfterSignIn?: boolean }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const runner = useRun(MESSAGES);

  async function submit() {
    const ok = await runner.run(async () => { await api.login(username.trim(), password); });
    if (ok) { onSignedIn(); go(whereTheyWear()); }
  }
  // the person is put back where the session ended, not at the front door
  function whereTheyWear(): string { return whereTheyWere(); }

  return (
    <div className="signin">
      <section className="card">
        <div className="card-body">
          <h1>Cylinder Tracking System</h1>
          <p className="sub">Sign in to continue.</p>
          {runner.error ? <Banner kind="error" title={runner.error.title} {...(runner.error.detail ? { detail: runner.error.detail } : {})} /> : null}
          {failedAfterSignIn ? (
            <Banner kind="warn" title="The password was accepted, but the session could not be read back."
                    detail="This usually means the browser is refusing the session cookie — check that you opened the company's own address." />
          ) : null}
          <form onSubmit={(e: { preventDefault: () => void }) => { e.preventDefault(); void submit(); }}>
            <Text name="username" label="Username" value={username} onChange={setUsername} autoFocus required />
            <Text name="password" label="Password" type="password" value={password} onChange={setPassword} required />
            <Button type="submit" kind="primary" wide disabled={runner.busy || !username.trim() || !password}>
              {runner.busy ? 'Signing in…' : 'Sign in'}
            </Button>
          </form>
        </div>
      </section>
    </div>
  );
}
